export default __webpack_public_path__ + "static/media/aj-logo.ad10bbf6.png";